import { render, staticRenderFns } from "./ToBandCard.vue?vue&type=template&id=17f60b3f&scoped=true&"
import script from "./ToBandCard.vue?vue&type=script&lang=js&"
export * from "./ToBandCard.vue?vue&type=script&lang=js&"
import style0 from "./ToBandCard.vue?vue&type=style&index=0&id=17f60b3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f60b3f",
  null
  
)

export default component.exports